/* THIS FILE WAS AUTO-GENERATED. DO NOT MODIFY */
/* eslint-disable */
import * as SchemaTypes from '../../../types/graph';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetHeaderDataQueryVariables = SchemaTypes.Exact<{ [key: string]: never; }>;


export type GetHeaderDataQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, email: string | null, firstName: string | null } };


export const GetHeaderDataDocument = gql`
    query GetHeaderData {
  currentUser {
    id
    email
    firstName
  }
}
    `;
export function useGetHeaderDataQuery(baseOptions?: Apollo.QueryHookOptions<GetHeaderDataQuery, GetHeaderDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHeaderDataQuery, GetHeaderDataQueryVariables>(GetHeaderDataDocument, options);
      }
export function useGetHeaderDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHeaderDataQuery, GetHeaderDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHeaderDataQuery, GetHeaderDataQueryVariables>(GetHeaderDataDocument, options);
        }
export function useGetHeaderDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHeaderDataQuery, GetHeaderDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHeaderDataQuery, GetHeaderDataQueryVariables>(GetHeaderDataDocument, options);
        }
export type GetHeaderDataQueryHookResult = ReturnType<typeof useGetHeaderDataQuery>;
export type GetHeaderDataLazyQueryHookResult = ReturnType<typeof useGetHeaderDataLazyQuery>;
export type GetHeaderDataSuspenseQueryHookResult = ReturnType<typeof useGetHeaderDataSuspenseQuery>;
export type GetHeaderDataQueryResult = Apollo.QueryResult<GetHeaderDataQuery, GetHeaderDataQueryVariables>;